<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="topbar">
        <div>
          <el-input
              v-model="searchValue"
              placeholder="请输入搜索内容"
              size="small"
              prefix-icon="el-icon-search"
              @keyup.enter.native="search()"
              clearable
          />
          <el-button style="margin-left: 20px" type="primary" size="small" @click="search">搜索</el-button>
        </div>
      </div>
      <el-table
          border
          ref="table"
          :data="tableData"
          :header-cell-style="{ background: '#F5F7FA' }"
          style="width: 100%; margin-bottom: 20px"
          v-loading="loading"
      >
        <el-table-column label="ID" prop="feedbackId" align="center"></el-table-column>
        <el-table-column label="sn" prop="sn" align="center"></el-table-column>
        <el-table-column label="标题" prop="title" align="center"></el-table-column>
        <el-table-column label="内容" prop="content" align="center" show-tooltip-when-overflow></el-table-column>
        <el-table-column label="提交者" align="center">
          <template #default="scope">
            <user-info :user="scope.row"></user-info>
          </template>
        </el-table-column>
        <el-table-column label="提交时间" prop="createTime" align="center">
          <template #default="scope">
            {{ scope.row.createTime | formatDateTime }}
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center">
          <template #default="scope">
            <el-button type="success" size="small" @click="go2DeviceFeedbackDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>

      </el-table>
      <el-pagination background :total="pageOpt.total" :page-size="pageOpt.pageSize" :current-page="pageOpt.curPage"
                     @current-change="currentPageChange"/>

    </el-card>
  </div>

</template>

<script>
import {getDeviceFeedbackList} from "@/api/feedback";
import {handleRes} from "@/utils/handleRes";
import UserInfo from "@/components/UserInfo/UserInfo";
import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";

export default {
  name: "DeviceFeedback",
  components: {UserInfo},
  created() {
    let navigationObj = getNavigationItemObj(this.navigationKey)
    this.pageOpt.curPage = navigationObj.curPage
    this.searchValue = navigationObj.searchValue

    this.getDeviceFeedbackList()
  },
  data() {
    return {
      navigationKey: "deviceFeedback",

      loading: false,
      searchValue: "",
      pageOpt: {
        curPage: 1,
        pageSize: 10,
        total: 0
      },
      tableData: [],
    }
  },
  methods: {
    currentPageChange(curPage) {
      this.pageOpt.curPage = curPage
      this.getDeviceFeedbackList()
    },
    search() {
      this.refreshList()
    },
    refreshList() {
      this.pageOpt.curPage = 1
      this.getDeviceFeedbackList()
    },
    getDeviceFeedbackList() {
      this.loading = true

      setNavigationItemWithObj(this.navigationKey, {
        curPage: this.pageOpt.curPage,
        searchValue: this.searchValue
      })

      getDeviceFeedbackList({
        keyWord: this.searchValue,
        pageNumber: this.pageOpt.curPage,
        pageSize: this.pageOpt.pageSize,
      }).then(res => {
        handleRes(res, () => {
          this.tableData = res.data.rows
          this.pageOpt.total = res.data.total
        })
        this.utils.stopLoading(this)
      })
    },
    go2DeviceFeedbackDetail(entity) {
      this.$router.push({
        path: "deviceFeedbackDetail",
        query: {
          feedbackId: entity.feedbackId
        }
      })
    }
  }
}
</script>

<style scoped>

</style>